import { useCallback, useEffect, type RefObject } from "react";

// Синхронизирует scroll-позицию overlay-слоя с textarea: подсветка чипов
// должна следовать за прокруткой текста, иначе при длинном шаблоне они
// разъедутся при scroll'е каретки.
export const useScrollSync = (
  sourceRef: RefObject<HTMLElement | null>,
  mirrorRef: RefObject<HTMLElement | null>,
  trigger: unknown,
) => {
  const sync = useCallback(() => {
    const src = sourceRef.current;
    const mir = mirrorRef.current;
    if (!src || !mir) return;
    mir.scrollTop = src.scrollTop;
    mir.scrollLeft = src.scrollLeft;
  }, [sourceRef, mirrorRef]);

  useEffect(() => {
    sync();
  }, [trigger, sync]);

  return sync;
};
